import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Abastecimento',
    parent: 'traveiculo',
    path: '/transporte/traabastecimento/:traVeiculoId',
    name: 'traabastecimento',
    component: () => import('@/views/transporte/traabastecimento/CadastroComGrid.vue'),
    meta: {
      permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299],
    },
    goesToMenu: false,
  },
];
